import { Notyf }        from    'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const DetailLocalMethods = {

    watch: {
        'task_form_data.task_id'(val)
        {
            if(val)
            {
                this.task_selected = this.array_options.task_id.find(item => item.id === val)
                this.task_form_data.minutes = this.task_selected.unit ? (this.task_selected.production_standard ? this.task_selected.production_standard : 0 ) * (this.single_object.fixtures !== undefined ? this.single_object.fixtures.length : 0) : (this.task_selected.production_standard ? this.task_selected.production_standard : 0 ) * Number(this.single_object.sq_ft)
                this.task_selected.project ? this.freq_manual = false : this.freq_manual = true
            }
            else
            {
                this.task_selected = {}
            }
        },

        'single_object.patient'(val)
        {
            if(val)
            {
                this.fixtures_backup = JSON.parse(JSON.stringify(this.single_object.fixtures))
                this.single_object.fixtures = this.single_object.fixtures.slice(0, 6)
                if(this.single_object.fixture_number > 6)
                {
                    this.single_object.fixture_number = 6
                }
                else
                {
                    this.fixtureChange(this.single_object.fixture_number, this.single_object.fixtures.length)
                }
            }
            else
            {
                this.single_object.fixtures = this.fixtures_backup
                this.fixtures_backup = JSON.parse(JSON.stringify(this.single_object.fixtures))
            }
        },

        'single_object.room_type_id'(val)
        {
            if(val)
            {
                
                this.global_room_type = this.array_options['room_type_id'].find((data) => data.id === val)

                let patient = this.global_room_type.patient

                this.suggested_floor_type = this.array_options['floor_id'].find((data) => data.id === this.global_room_type['floor_id'])

                this.suggested_daily_tasks = this.global_room_type.daily_tasks

                this.suggested_policing_tasks = this.global_room_type.policing_tasks

                if(this.first_time > 1)
                { 
                    this.single_object.fixtures = []

                    if(this.single_object.room_type_id === this.single_object_backup.room_type_id)
                    {
                        if(this.single_object_backup.fixtures.length)
                        {
                            this.single_object.fixtures = [...this.single_object_backup.fixtures]

                            this.single_object.fixture_number = this.single_object_backup.fixtures.length
                        }
                        else
                        {
                            if(this.global_room_type.unit)
                            {
                                this.single_object.fixture_number = this.global_room_type.unit
                            }
                        }
                        
                    }
                    else
                    {
                        if(this.global_room_type.unit)
                        {
                            this.single_object.fixture_number = this.global_room_type.unit
                        }
                    }
                }

                if(this.patient_counter)
                {
                    this.confirmation_status = false
                    this.single_object.patient = Boolean(patient)

                    if(this.global_room_type.task_id) 
                    {
                        this.single_object.daily_task_id = this.global_room_type.task_id
                    }
                    else
                    {
                        this.single_object.daily_task_id = null
                    }

                }

                this.patient_counter++
            }
            this.first_time++ 
        },

        'single_object.door_number'(val)
        {
            if(!this.first_time_door_number)
            {
                let number_position = 0

                this.single_object.fixtures.forEach((fixture, index) => 
                {
                    let bed_number = this.bed_numbers[number_position] ? this.bed_numbers[number_position] : ''

                    if(val === '' || val === null)
                    {
                        fixture.name = `${index+1} ${bed_number}`
                        
                    }
                    else
                    {
                        fixture.name = `${val}${bed_number}`
                    }

                    number_position++
                    
                });
            }
            this.first_time_door_number = false
        },

        
    },

    methods:{
        updateFrequencyValue()
        {
            this.calculating_frequency_value = true
            const { frequency_manual, shift1, shift2, shift3, previous_frequency_manual } = this.task_form_data;

            if (frequency_manual) 
            {
                const activeShifts = [shift1, shift2, shift3].filter(Boolean).length;

                if (activeShifts > 1) 
                {
                    this.task_form_data.frequency_manual = previous_frequency_manual * activeShifts;
                } 
                else
                {
                    this.task_form_data.frequency_manual = previous_frequency_manual;
                }
            }
            setTimeout(() => {
                this.calculating_frequency_value = false
            }, 200)
        },

        changingTaskFrequency()
        {
            this.task_form_data.previous_frequency_manual = Number(this.task_form_data.frequency_manual)

            this.calculating_frequency_value = true
            setTimeout(() => {
                this.updateFrequencyValue()
            }, 400);
        },

        updateFrequencyValueOfExistingTask(task)
        {
            task.calculating_frequency_value = true
            const { shift1, shift2, shift3, previous_frequency_manual } = task

            if (task.frequency_manual) 
            {
                const activeShifts = [shift1, shift2, shift3].filter(Boolean).length;

                if (activeShifts > 1) 
                {
                    task.frequency_manual = (previous_frequency_manual * activeShifts).toFixed(2);
                } 
                else
                {
                    task.frequency_manual = (previous_frequency_manual).toFixed(2);
                }

                task.frequency_manual = parseFloat(task.frequency_manual);
            }
            setTimeout(() => {
                task.calculating_frequency_value = false
            }, 300)
        },

        changingTaskFrequencyOfExistingTask(task)
        {
            task.previous_frequency_manual = Number(task.frequency_manual)
            task.calculating_frequency_value = true
            setTimeout(() => {
                this.updateFrequencyValueOfExistingTask(task)
            }, 400);
        },

        manualFrequencyInspection(index)
        {
            if(this.daily_tasks[index].frequency_manual < 0)
            {
                window.$(`#select1${index}`).focus()
                this.daily_tasks[index].frequency_manual = 0
                notyf.error('Forbidden frequency value')
            }
        },

        manualFrequencyInspectionPolicing(index)
        {
            if(this.policing_tasks[index].frequency_manual < 0)
            {
                window.$(`#select1_policing${index}`).focus()
                this.policing_tasks[index].frequency_manual = 0
                notyf.error('Forbidden frequency value')
            }
        },

        minutesInspection(index)
        {
            if(this.daily_tasks[index].minutes_discount > this.daily_tasks[index].minutes)
            {
                this.daily_tasks[index].minutes_discount = 0
            }
        },

        inspectionDailyMinute(index, minute)
        {
            if(minute > 1000 || minute < -1000)
            {
                this.daily_tasks[index].minutes_discount = 0
            }
        },

        inspectionProjectMinute(index, minute)
        {
            if(minute > 1000 || minute < -1000)
            {
                this.project_tasks[index].minutes_discount = 0
            }
        },

        elements_getter(event)
        {
            event.data['next']      = event.next
            event.data['previous']  = event.previous
            this.single_object = {...event.data}
            this.single_object_backup = {...event.data}
            this.title_page = `${this.single_object.walking_number} - ${this.single_object.description} ${this.single_object.child ? ` - <span class='supervisor-text-color'>Internal room to ${this.single_object.parent_description} <i class='fa fa-check-circle'/> </span>` : ''}`
            this.breadcrumb[3].name = this.single_object.description
            let fixtures_server = event.data.fixtures
            this.single_object.fixtures = fixtures_server
            this.new_tasks = event.new_tasks
            this.assignments = event.daily_assignments
        },

        saveGrid(clicked = false, tasks = {})
        {
            this.single_object['tasks'] = tasks

            if(this.task_form_data.task_id !== '')
            {
                this.submit_reactive = true
                this.form_submit(true)
                return true
            }

            if(clicked)
            {
                this.$refs.DetailComponentRoom.live_edition(true)
                return true
            }

            this.submit_reactive = false

            if(this.new_tasks)
            {
                this.tasks_request()
                this.new_tasks = false
            }
            else
            {
                // this.tasks_request()
                this.sort_tasks()
            }

        },

        async tasks_request()
        {
            let json_request = {
                room_id: this.parent_id,
                taskmate: true,
            }

            let response = await this.get(`${this.ext_rest_api}/${JSON.stringify(json_request)}`)

            if(response.status)
            {
                this.tasks = []
                this.tasks = response.data.room_tasks
                this.task_getter(this.tasks)
                this.sort_tasks()
            }
            else
            {
                this.error_handling(response)
            }
        },

        sort_tasks()
        {
            let daily_tasks = []
            
            let policing_tasks = []
            
            let project_tasks = []

            if(this.daily_tasks.length)
            {
                console.log('sort_tasks')
                
                for(let i = 0; i < this.daily_tasks.length; i++)
                {
                    // if(this.daily_tasks[i].frequency_manual === '' || this.daily_tasks[i].frequency_manual === 0)
                    // {
                    //     setTimeout(()=>{
                    //         window.$(`#select1${i}`).focus()
                    //     }, 500)
                    //     notyf.error('Frequency cannot be empty or zero')
                    //     return false
                    // }

                    if(Number(this.daily_tasks[i].minutes_discount) > 1000 || Number(this.daily_tasks[i].minutes_discount) < -1000)
                    {
                        setTimeout(()=>{
                            window.$(`#select_minute${i}`).focus()
                        }, 500)
                        notyf.error('Invalid number')
                        return false
                    }

                    let current_task = {
                        id:               this.daily_tasks[i].id,
                        frequency_id:     '',
                        frequency_manual: this.daily_tasks[i].frequency_manual,
                        time_adjustment:  Number(this.single_object.time_adjustment),
                        minutes_discount: Number(this.daily_tasks[i].minutes_discount),
                        minutes:          Number(this.daily_tasks[i].minutes),
                        shift1:           this.daily_tasks[i].shift1,
                        shift2:           this.daily_tasks[i].shift2,
                        shift3:           this.daily_tasks[i].shift3,
                        project:          this.daily_tasks[i].project,
                        task_id:          this.daily_tasks[i].task_id,
                        order:            i,
                    }
                    daily_tasks.push(current_task)
                }
            }

            if(this.policing_tasks.length)
            {
                for(let i = 0; i < this.policing_tasks.length; i++)
                {
                    // if(this.policing_tasks[i].frequency_manual === '' || this.policing_tasks[i].frequency_manual === 0)
                    // {
                    //     setTimeout(()=>{
                    //         window.$(`#select1_policing${i}`).focus()
                    //     }, 500)
                    //     notyf.error('Frequency cannot be empty or zero')
                    //     return false
                    // }

                    if(Number(this.policing_tasks[i].minutes_discount) > 1000 || Number(this.policing_tasks[i].minutes_discount) < -1000)
                    {
                        setTimeout(()=>{
                            window.$(`#select_policing_minute${i}`).focus()
                        }, 500)
                        notyf.error('Invalid number')
                        return false
                    }

                    let current_task = {
                        id:               this.policing_tasks[i].id,
                        frequency_id:     '',
                        frequency_manual: this.policing_tasks[i].frequency_manual,
                        time_adjustment:  Number(this.single_object.time_adjustment),
                        minutes_discount: Number(this.policing_tasks[i].minutes_discount),
                        minutes:          Number(this.policing_tasks[i].minutes),
                        shift1:           this.policing_tasks[i].shift1,
                        shift2:           this.policing_tasks[i].shift2,
                        shift3:           this.policing_tasks[i].shift3,
                        project:          this.policing_tasks[i].project,
                        task_id:          this.policing_tasks[i].task_id,
                        order:            i,
                    }
                    policing_tasks.push(current_task)
                }
            }

            if(this.project_tasks.length)
            {
                for(let i = 0; i < this.project_tasks.length; i++)
                {
                    if(this.project_tasks[i].frequency_id === '')
                    {
                        window.$(`#selectFreq${i}`).focus()
                        notyf.error('Frequency cannot be empty')
                        return false
                    }

                    if(Number(this.project_tasks[i].minutes_discount) > 1000 || Number(this.project_tasks[i].minutes_discount) < -1000)
                    {
                        setTimeout(()=>{
                            window.$(`#select_project_minute${i}`).focus()
                        }, 500)
                        notyf.error('Invalid number')
                        return false
                    }

                    let current_task = {
                        id:               this.project_tasks[i].id,
                        frequency_id:     this.project_tasks[i].frequency_id,
                        frequency_manual: '',
                        minutes_discount: Number(this.project_tasks[i].minutes_discount),
                        minutes:          Number(this.project_tasks[i].minutes),
                        shift1:           this.project_tasks[i].shift1,
                        shift2:           this.project_tasks[i].shift2,
                        shift3:           this.project_tasks[i].shift3,
                        task_id:          this.project_tasks[i].task_id,
                        project:          this.project_tasks[i].project,
                    }
                    project_tasks.push(current_task)
                }
            }

            let json_request = {
                id: this.single_object.id,
                field: 'mass_tasks_edit',
            }

            let semi_final = daily_tasks.concat(policing_tasks)

            let final_tasks = semi_final.concat(project_tasks)

            if(final_tasks.length)
            {
                this.mixUpdate(json_request, final_tasks)
            }
        },

        dailyDisabled()
        {
            let json_request = {
                id: this.single_object.id,
                field: 'disabled_daily',
            }
            let request_data = {
                boolean_value: this.single_object.disabled_daily,
            }
            this.mixUpdate(json_request, request_data)
        },

        policingDisabled()
        {
            let json_request = {
                id: this.single_object.id,
                field: 'disabled_policing',
            }
            let request_data = {
                boolean_value: this.single_object.disabled_policing,
            }
            this.mixUpdate(json_request, request_data)
        },

        projectDisabled()
        {
            let json_request = {
                id: this.single_object.id,
                field: 'disabled_project',
            }
            let request_data = {
                boolean_value: this.single_object.disabled_project,
            }
            this.mixUpdate(json_request, request_data)
        },

        async mixUpdate(json_request, request_data)
        {
            this.loader(true)
            const response = await this.patch(`${this.ext_rest_api}/${JSON.stringify(json_request)}`, request_data)
            if(response.status)
            {
                if(response.data.room_tasks !== undefined)
                {
                    this.tasks = []
                    this.tasks = response.data.room_tasks
                    this.task_getter(this.tasks)

                    this.single_object.time_adjustment = response.data.time_adjustment
                }
                this.loader()
                notyf.success('Success')
            }
            else
            {
                this.loader()
                notyf.error('Error')
                this.error_handling(response)
            }
        },

        async task_drop(index)
        {
            let confirm = window.confirm('Are you sure to remove the selected item?')

            if(confirm)
            {
                this.get_loader()
                let daily_task_id = this.daily_tasks[index].id
                const response = await this.delete(`${this.ext_rest_api}/${daily_task_id}`)
                if(response.status)
                {
                    this.daily_tasks.splice(index, 1)
                    notyf.success('Success')
                    this.hide_loader()
                } 
                else
                {
                    this.error_handling(response)
                    this.hide_loader()
                }
            }
        },

        async policing_drop(index)
        {
            let confirm = window.confirm('Are you sure to remove the selected item?')

            if(confirm)
            {
                this.get_loader()
                let policing_task_id = this.policing_tasks[index].id
                const response = await this.delete(`${this.ext_rest_api}/${policing_task_id}`)
                if(response.status)
                {
                    this.policing_tasks.splice(index, 1)
                    notyf.success('Success')
                    this.hide_loader()
                } 
                else
                {
                    this.error_handling(response)
                    this.hide_loader()
                }
            }
        },

        async project_drop(index)
        {
            let confirm = window.confirm('Are you sure to remove the selected item?')
            if(confirm)
            {
                this.get_loader()
                let project_task_id = this.project_tasks[index].id
                const response = await this.delete(`${this.ext_rest_api}/${project_task_id}`)
                if(response.status)
                {
                    this.project_tasks.splice(index, 1)
                    notyf.success('Success')
                    this.hide_loader()
                } 
                else
                {
                    this.error_handling(response)
                    this.hide_loader()
                }
            }
        },

        async form_submit(clicked = false)
        {
            if(clicked)
            {
                this.$refs.saveTaskButton.click()
                return true
            }

            this.loader(true)
            const response = await this.post(this.ext_rest_api, this.task_form_data)

            if(response.status)
            {
                this.task_form_data = {...this.task_form_data_backup}
                this.freq_manual = true

                if(this.submit_reactive)
                {   
                    this.submit_reactive = false
                    this.saveGrid(true)
                }
                else
                {
                    this.loader()
                }
            } 
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        fill_data(data)
        {
            this.rooms = data.rooms

            this.assignments = data.daily_assignments

            this.single_object                  =  {...data.room}
            this.single_object_backup           =  {...data.room}
            this.is_description_dynamic         =  data.room.default_description
            this.bed_numbers                    =  data.bed_numbers
            this.single_object.next             =  data.next
            this.single_object.previous         =  data.previous
            this.task_form_data.room_id         =  this.single_object.id
            this.task_form_data_backup.room_id  =  this.single_object.id
            this.child_next_walking_number      =  data.child_next_walking_number

            this.array_options = {
                area_id:        data.areas,
                room_type_id:   data.room_types,
                cost_center_id: data.cost_centers,
                floor_id:       data.floors,
                task_id:        data.tasks,
                frequency_id:   data.frequencies,
                daily_task_id:  data.daily_tasks,
            }

            this.tasks = data.room_tasks

            this.task_getter(this.tasks)

            this.title_page = `${this.single_object.walking_number} - ${this.single_object.description} ${this.single_object.child ? ` - <span class='supervisor-text-color'>Internal room to ${this.single_object.parent_description} <i class='fa fa-check-circle'/> </span>` : ''}`
            this.breadcrumb[2].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.description,
                href:   '#',
                arrow:  " ",
            })
        },

        task_getter(tasks)
        {
            this.project_tasks = []
            this.daily_tasks = []
            this.policing_tasks = []

            if(tasks.length)
            {
                let dailys = tasks.filter(item => !item.policing && !item.project)
                let policings = tasks.filter(item => item.policing && !item.project)
                let projects = tasks.filter(item => item.project)

                this.daily_tasks = [...dailys]
                this.policing_tasks = [...policings]
                this.project_tasks = [...projects]
            }
        }

    },

}

export default DetailLocalMethods